export const PERSONAL_SIGNATURE_INTERNAL = "personal_signature_internal";
export const CREATE_SIGNATURE_PROCESS_INTERNAL = "create_signature_process_internal";
export const PERSONAL_SIGNATURE_EXTERNAL = "personal_signature_external";
export const CREATE_SIGNATURE_PROCESS_EXTERNAL = "create_signature_process_external";

export const LEARN_MORE = "learn_more";

export const PROMOTIONAL_ENTRANCE = "promotional_entrance";

export const eSign = {
    [PERSONAL_SIGNATURE_INTERNAL]: {category: 'eSign', action: PERSONAL_SIGNATURE_INTERNAL},
    [CREATE_SIGNATURE_PROCESS_INTERNAL]: {category: 'eSign', action: CREATE_SIGNATURE_PROCESS_INTERNAL },
    [PERSONAL_SIGNATURE_EXTERNAL]: {category: 'eSign', action: PERSONAL_SIGNATURE_EXTERNAL},
    [CREATE_SIGNATURE_PROCESS_EXTERNAL]: {category: 'eSign', action: CREATE_SIGNATURE_PROCESS_EXTERNAL },
    [LEARN_MORE]: {category: 'eSign', action: LEARN_MORE },
    [PROMOTIONAL_ENTRANCE]: {category: 'eSign', action: PROMOTIONAL_ENTRANCE },
  };


export const EVENT_ESIGN = [
    PERSONAL_SIGNATURE_INTERNAL,
    CREATE_SIGNATURE_PROCESS_INTERNAL,
    PERSONAL_SIGNATURE_EXTERNAL,
    CREATE_SIGNATURE_PROCESS_EXTERNAL,
    LEARN_MORE,
    PROMOTIONAL_ENTRANCE,
]